module.exports = __webpack_public_path__ + "static/img/007.218eca3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperator/007.png
// module id = Sx50
// module chunks = 0